import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, InfoTag, Typography, getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { CalloutWidgetComponent } from '../../../../components/callout-widget/CalloutWidget';
import { getDynamicScrollListStyles } from './TitleAndBannerStyles';
export var TitleAndBanner = props => {
  var title = props.title,
    infoTagProps = props.infoTagProps,
    calloutWidgetProps = props.calloutWidgetProps,
    showCallout = props.showCallout,
    onUserAction = props.onUserAction,
    testID = props.testID,
    typoGraphyAndInfotagWrapperStyle = props.typoGraphyAndInfotagWrapperStyle,
    _props$isBold = props.isBold,
    isBold = _props$isBold === void 0 ? false : _props$isBold;
  var dynamicScrollListWidgetStyles = getDynamicScrollListStyles();
  return _jsxs(_Fragment, {
    children: [(!!title || !!(infoTagProps === null || infoTagProps === void 0 ? void 0 : infoTagProps.text)) && _jsxs(View, Object.assign({
      style: [dynamicScrollListWidgetStyles === null || dynamicScrollListWidgetStyles === void 0 ? void 0 : dynamicScrollListWidgetStyles.typoGraphyAndInfotagWrapper, typoGraphyAndInfotagWrapperStyle]
    }, getTestId(testID, 'titleWrapper'), {
      children: [!!title && _jsx(Typography, Object.assign({
        style: dynamicScrollListWidgetStyles === null || dynamicScrollListWidgetStyles === void 0 ? void 0 : dynamicScrollListWidgetStyles.typographyStyle,
        color: isBold ? BLACK_900 : BLACK_700,
        noTextTransform: true,
        text: title,
        theme: "light",
        type: isBold ? 'body-single-line-md-bold' : 'body-single-line-lg'
      }, getTestId(testID, 'title'))), !!infoTagProps && _jsx(InfoTag, Object.assign({}, infoTagProps, getTestId(testID, 'infoTag')))]
    })), !!showCallout && _jsx(View, Object.assign({
      style: dynamicScrollListWidgetStyles === null || dynamicScrollListWidgetStyles === void 0 ? void 0 : dynamicScrollListWidgetStyles.calloutWidgetWrapper
    }, getTestId(testID, 'calloutWrapper'), {
      children: _jsx(CalloutWidgetComponent, Object.assign({
        style: dynamicScrollListWidgetStyles === null || dynamicScrollListWidgetStyles === void 0 ? void 0 : dynamicScrollListWidgetStyles.calloutWidgetStyle,
        testID: testID + '_callout'
      }, calloutWidgetProps, {
        onUserAction: onUserAction
      }))
    }))]
  });
};